import { doc, getDoc, getFirestore } from "firebase/firestore";
import useSWR from "swr";
import { firebaseApp } from "../../../firebase/firebaseClient";
import { UserModule } from "../../../models/users";

const fetcher = async (url: string, module_ids: string) => {
  if (url) {
    const splits = url.split(`/`);
    const user_id = splits[2];
    const module_ids_array: string[] = module_ids.split(",");
    const firestore = getFirestore(firebaseApp);
    const promiseArray = [];
    module_ids_array.forEach((module_id) => {
      promiseArray.push(
        getDoc(doc(firestore, "users", user_id, "learning_modules", module_id))
      );
    });
    const results = await Promise.all(promiseArray);
    const userModules: UserModule[] = [];
    results.forEach((snap) => {
      userModules.push(snap.data());
    });
    return userModules;
  } else {
    return undefined;
  }
};

function useUserLearningModules(user_id?: string, module_ids?: string[]) {
  const { data, mutate, error } = useSWR(
    [
      user_id && module_ids?.length > 0
        ? `/users/${user_id}/learning_modules/${module_ids.toString()}`
        : null,
      module_ids?.toString(),
    ],
    fetcher
  );
  const result: {
    userModules: UserModule[];
    isLoading: boolean;
    isError: boolean;
    mutate: any;
  } = {
    userModules: data as any,
    isLoading: !error && !data,
    isError: error,
    mutate,
  };
  return result;
}

export default useUserLearningModules;
